export const calendarModals = {
  common: {
    cancel: "Anuluj",
  },
  arrival: {
    title: "Zasady kalendarza",
    loading: "Wczytywanie ustawień…",
    daysTitle: "Dni przyjazdu i wyjazdu",
    canArrive: "Goście mogą przyjeżdżać",
    canDepart: "Goście mogą wyjeżdżać",
    daysHint:
      "Gdy <b>wszystko jest zaznaczone</b>, nie ma żadnych ograniczeń. Jeśli przyjazdy są dozwolone tylko w poniedziałek, a wyjazdy w niedzielę, każda rezerwacja potrwa dokładnie tydzień.",
    summaryAny: "Goście mogą przyjeżdżać i wyjeżdżać dowolnego dnia",
    summaryArrival: "przyjazd w {n} z 7 dni",
    summaryDeparture: "wyjazd w {n} z 7 dni",
    summaryRestricted: "Ograniczenia: {detail}",
    cutoffTitle: "Zamykanie sprzedaży na dziś po określonej godzinie",
    cutoffToggle: "Automatycznie zamykaj sprzedaż na ten sam dzień",
    cutoffToggleHint: "Gdy opcja jest wyłączona, check-iny na dziś są przyjmowane o każdej porze.",
    cutoffFrom: "Od",
    cutoffTz: "czas obiektu",
    cutoffTzNow: "jest tam {time}",
    cutoffHintPre: "Codziennie o ",
    cutoffHintMid: " czasu ",
    cutoffHintPost:
      " rezerwacje na ten sam dzień przestają być przyjmowane. Kolejne dni pozostają otwarte jak zwykle.",
    cutoffSummaryOn: "Sprzedaż zamyka się codziennie o {time}",
    cutoffSummaryOff: "Check-iny na dziś przyjmowane są o każdej porze",
    turnoverTitle: "Czas na przygotowanie",
    turnoverQuestion: "Ile nocy potrzeba między jednym gościem a kolejnym?",
    turnoverOptNone: "Brak",
    nights: "{count} noc | {count} noce | {count} nocy",
    custom: "Własne",
    customLabel: "Noce",
    customAside: "z każdej strony, maks. 7",
    turnoverSummaryNone: "Goście mogą przyjechać tego samego dnia, w którym inny wyjeżdża",
    turnoverSummarySet: "Przerwa między jednym gościem a kolejnym: {nights}",
    turnoverLegacySummaryAfter: "Obecnie obowiązuje tylko po check-oucie · zapis obejmie obie strony",
    turnoverLegacySummaryBefore: "Obecnie obowiązuje tylko przed check-inem · zapis obejmie obie strony",
    turnoverLegacyNoteAfter: "Ta zasada pochodzi z poprzedniej wersji i obecnie blokuje tylko po check-oucie, a nie przed check-inem. Zapis zastosuje ją po obu stronach, a wcześniej pokażemy, ile nocy zostanie zamkniętych.",
    turnoverLegacyNoteBefore: "Ta zasada pochodzi z poprzedniej wersji i obecnie blokuje tylko przed check-inem, a nie po check-oucie. Zapis zastosuje ją po obu stronach, a wcześniej pokażemy, ile nocy zostanie zamkniętych.",
    exampleLabel: "Przykład",
    exampleCaption: "Rezerwacja z przyjazdem 15. i wyjazdem 18.",
    legendStay: "Pobyt",
    legendPrep: "Przygotowanie",
    legendFree: "W sprzedaży",
    turnoverMoveHint:
      "Blokada przesuwa się sama, gdy zmienią się daty, i znika, gdy rezerwacja zostanie anulowana.",
    impactClosePre: "W kanałach zamknie się: ",
    impactClosePost: ".",
    impactOpenPre: "Otworzy się: ",
    impactOpenPost: ".",
    impactRetry: "Proszę nacisnąć „Zapisz zasady” jeszcze raz, aby to zastosować.",
    fallbackHost: "obiektu",
    saving: "Zapisywanie…",
    applyYes: "Tak, zastosuj",
    saveRules: "Zapisz zasady",
    loadError: "Nie udało się wczytać ustawień.",
    saveSuccess: "Zasady kalendarza zapisane i wysłane do kanałów.",
    saveError: "Nie udało się zapisać.",
    saveConfigError: "Nie udało się zapisać ustawień.",
    linkedTitle: "Sprzedaż całego mieszkania",
    linkedSummaryOff: "Ta jednostka sprzedawana jest osobno",
    linkedSummaryOn: "Sprzedaż całego lokalu · obejmuje {count} pokój | Sprzedaż całego lokalu · obejmuje {count} pokoje | Sprzedaż całego lokalu · obejmuje {count} pokoi",
    linkedSummaryChild: "Część całości: {parent}",
    linkedRooms: "{count} pokój | {count} pokoje | {count} pokoi",
    linkedToggle: "Ustaw jako całe mieszkanie tej oferty",
    linkedToggleHint: "Dla jednostki wynajmowanej jako cały lokal. Następnie trzeba wybrać, które pokoje obejmuje.",
    linkedQuestion: "Które pokoje obejmuje?",
    linkedAll: "Zaznacz wszystkie",
    linkedNone: "Odznacz wszystkie",
    linkedIsParent: "Już sprzedawany jako całe mieszkanie",
    linkedGuests: "{count} gość | {count} goście | {count} gości",
    linkedExampleCaption: "«{room}» jest zarezerwowany od 19. do 21.",
    linkedExampleRoom: "Pokój 1",
    linkedLegendClosed: "Zamyka się automatycznie",
    linkedHint: "Działa to też w drugą stronę: gdy zarezerwowane jest całe mieszkanie, zamykają się wszystkie jego pokoje. Jeśli rezerwacja zostanie anulowana albo zmienią się jej daty, wszystko otwiera się samo, również w kanałach. Dopóki rezerwacja obowiązuje, tych blokad nie da się otworzyć ręcznie.",
    linkedChildPre: "Ten pokój wchodzi w skład całego mieszkania: ",
    linkedChildPost: ". Gdy pokój zostanie zarezerwowany, całe mieszkanie zamyka się na te noce; a gdy zarezerwowane zostanie całe mieszkanie, ten pokój zamyka się sam. Można to zmienić w zasadach kalendarza całego mieszkania.",
    linkedConflicts: "Między całym mieszkaniem a jego pokojami jest już {count} podwójna rezerwacja. Proszę ją sprawdzić: | Między całym mieszkaniem a jego pokojami są już {count} podwójne rezerwacje. Proszę je sprawdzić: | Między całym mieszkaniem a jego pokojami jest już {count} podwójnych rezerwacji. Proszę je sprawdzić:",
    linkedNeedsRooms: "Proszę wybrać co najmniej jeden pokój wchodzący w skład całego mieszkania.",
    linkedSaveError: "Nie udało się zapisać ustawień całego mieszkania.",
    linkedAlertTitle: "«{unit}» staje się całym mieszkaniem",
    linkedAlertBody: "Gdy zostanie zarezerwowane, wybrane pokoje zamkną się automatycznie, tutaj i w kanałach (Booking, Airbnb…). A gdy zarezerwowany zostanie któryś z tych pokoi, ta jednostka zamknie się na te noce. Jeśli rezerwacja zostanie anulowana, wszystko otwiera się samo.",
    linkedPartialSave: "Ustawienie całego mieszkania zostało zapisane, ale pozostałe zasady nie. Proszę spróbować ponownie.",
  },
  weekend: {
    title: "Ustawienia cen",
    subtitle: "Te informacje będą widoczne dla każdej nocy, o ile nie zostaną dostosowane według dat.",
    loading: "Wczytywanie ustawień…",
    plTitle: "Ceny zarządzane przez PriceLabs",
    plDesc1:
      "Ten obiekt ma włączone dynamiczne zarządzanie cenami w PriceLabs. Ceny aktualizują się automatycznie na podstawie popytu, sezonu i obłożenia.",
    plDesc2: "Ceny weekendowe zmienia się bezpośrednio w panelu PriceLabs.",
    plOpen: "Otwórz PriceLabs",
    basePriceTitle: "Cena bazowa",
    basePriceLabel: "Za noc, obowiązuje codziennie",
    customization: "Personalizacja",
    weekendPriceTitle: "Cena weekendowa",
    toggleOff: "Wyłącz cenę weekendową",
    toggleOn: "Włącz cenę weekendową",
    appliesTo: "Obowiązuje w:",
    weekendLabel: "Weekend",
    infoHint: "Zostanie zastosowana przez najbliższe <strong>500 dni</strong> w wybrane dni.",
    disabledText: "W dni weekendowe obowiązywać będzie cena bazowa",
    confirmTitle: "Wyłączyć cenę weekendową?",
    confirmDescPre: "Te dni wrócą do ceny bazowej",
    confirmDescPost: "automatycznie.",
    disabling: "Wyłączanie…",
    confirmDisable: "Tak, wyłącz",
    saving: "Zapisywanie…",
    saveChanges: "Zapisz zmiany",
    diffEqual: "tak jak bazowa",
    diffUp: "+{pct}% wobec bazowej",
    diffDown: "{pct}% wobec bazowej",
    loadError: "Błąd podczas wczytywania ustawień cen",
    disableSuccess: "Cena weekendowa wyłączona. Te dni wracają do ceny bazowej.",
    disableError: "Błąd podczas wyłączania ceny weekendowej",
    saveSuccess: "Ceny zapisane pomyślnie",
    saveError: "Błąd podczas zapisywania",
  },
};
